module.exports = __webpack_public_path__ + "static/media/lightbulb.e61a286a.svg";